/* istanbul ignore file */
import { loadScript } from '@web/common/Utils'
import sentry from '@web/common/sentry'
import getBaseUrl from '@web/common/getBaseUrl'
import urlParse from 'url-parse'
import Logger from '@web/common/Logger'

const COUNTER_ID = 'G-LK'

export default class TagManager {
  static id: string
  static config: Record<string, unknown>
  static typelk?: AnalyticsTypeLk

  static setConfig (config: Record<string, unknown>) {
    TagManager.config = {
      ...TagManager.config,
      ...config
    }
    if (window.gtag) {
      window.gtag('set', config)
    }
  }

  static logException () {
    if (!window.gtag) {
      if (process.env.NODE_ENV === 'production') {
        sentry.captureMessage('GTag not init')
      }
      // Logger.info('GTag not init')
    }
  }

  static init ({ userId, typelk }: { userId?: string | null, typelk?: AnalyticsTypeLk | null }): void {
    let transportUrlInstance = ''
    try {
      const urlInstance = urlParse(getBaseUrl(''), true)
      const host = urlInstance.host.replace('dev.', '')
      transportUrlInstance = urlParse(`${urlInstance.protocol}//sst.${host}`, true).toString()
    } catch (error) {
      Logger.error('Error parsing transport URL', error)
    }

    // toString() у url-parse добавляет хвостовой слеш — срезаем, иначе выйдет `//gtag/js`.
    if (transportUrlInstance) {
      loadScript(`${transportUrlInstance.replace(/\/$/, '')}/gtag/js?id=${COUNTER_ID}`)
    }

    window.dataLayer = window.dataLayer || []
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function gtag (...args) {
      window.dataLayer = window.dataLayer || []
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments)
    }
    gtag('js', new Date())
    TagManager.id = COUNTER_ID
    window.gtag = gtag
    const config = {
      send_page_view: true,
      transport_url: transportUrlInstance,
      ga4_id: COUNTER_ID,
      ...(userId ? { user_id: userId } : {}),
      ...(typelk ? { type_lk: typelk } : {})
    }
    TagManager.config = config
    gtag('config', COUNTER_ID, config)
  }

  static send ({ action, ...options }: EventBase): void {
    if (!window.gtag) {
      TagManager.logException()
      window.dataLayer?.push({
        event: action,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(options as any)
      })
      return
    }
    window.gtag('event', action, options)
  }

  static setUserId (id: string | null): void {
    if (!window.gtag) {
      TagManager.logException()
      return
    }
    TagManager.setConfig({
      user_id: id
    })
  }

  static setTypeLk (typelk?: AnalyticsTypeLk): void {
    if (!window.gtag) {
      TagManager.logException()
      return
    }
    TagManager.typelk = typelk
    TagManager.setConfig({ type_lk: TagManager.typelk })
  }
}
